import { motion } from "framer-motion";

/**
 * BlurText — Text blurs in from invisible on scroll.
 * Inspired by React Bits BlurText component.
 */
export default function BlurText({
  children,
  className = "",
  delay = 0,
  duration = 0.8,
  ...props
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, filter: "blur(12px)", y: 15 }}
      whileInView={{ opacity: 1, filter: "blur(0px)", y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
      {...props}
    >
      {children}
    </motion.div>
  );
}
